/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Clear_All_LabelInputs */

const en_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear all segments`)
};

const fr_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer tous les segments`)
};

const de_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Segmente löschen`)
};

const it_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella tutti i segmenti`)
};

const ru_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить все сегменты`)
};

const es_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todos los segmentos`)
};

const zh_cn2_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除所有段`)
};

const ja_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのセグメントをクリア`)
};

const hi_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी खंडों को साफ़ करें`)
};

const pt_pt2_segment_event_group_clear_all_label = /** @type {(inputs: Segment_Event_Group_Clear_All_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar todos os segmentos`)
};

/**
* | output |
* | --- |
* | "Clear all segments" |
*
* @param {Segment_Event_Group_Clear_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_clear_all_label = /** @type {((inputs?: Segment_Event_Group_Clear_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Clear_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_clear_all_label(inputs)
	if (locale === "de") return de_segment_event_group_clear_all_label(inputs)
	if (locale === "it") return it_segment_event_group_clear_all_label(inputs)
	if (locale === "ru") return ru_segment_event_group_clear_all_label(inputs)
	if (locale === "es") return es_segment_event_group_clear_all_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_clear_all_label(inputs)
	if (locale === "ja") return ja_segment_event_group_clear_all_label(inputs)
	if (locale === "hi") return hi_segment_event_group_clear_all_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_clear_all_label(inputs)
	return en_segment_event_group_clear_all_label(inputs)
});